import { render, staticRenderFns } from "./CategoryCustomFieldsTable.vue?vue&type=template&id=7c8e5280&scoped=true"
import script from "./CategoryCustomFieldsTable.vue?vue&type=script&lang=ts"
export * from "./CategoryCustomFieldsTable.vue?vue&type=script&lang=ts"
import style0 from "./CategoryCustomFieldsTable.vue?vue&type=style&index=0&id=7c8e5280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e5280",
  null
  
)

export default component.exports